import React from 'react'
import Item from '../list-item'
import Spinner from '../../common/spinner-container'
import useUserReflections from './use-user-reflections'

const ReflectionsList = ({
    userId
}) => {

    const { userReflections, isLoadingUserReflections } = useUserReflections({ userId })

    if (isLoadingUserReflections) {
        return (<Spinner />)
    }

    if (!userReflections.length) {
        return (<div className='text-center text-muted'>There are no reflections</div>)
    }

    const renderItem = (item, key) => {
        return (
            <Item key={key} userReflection={item} userId={userId} />
        )
    }

    return (
        <div>
            {userReflections.map(renderItem)}
        </div>
    )
}

export default ReflectionsList